import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/** Storage key — bumped so old silent confirmations no longer skip the gate. */
export const AGE_GATE_KEY = 'avto_tarix_age_ok_v2';

export const isAgeGatePassed = () => {
  try {
    return sessionStorage.getItem(AGE_GATE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setAgeGatePassed = () => {
  try {
    sessionStorage.setItem(AGE_GATE_KEY, 'true');
    localStorage.removeItem('ageConfirmed'); // clear legacy flag
  } catch {
    /* ignore */
  }
};

export const clearAgeGate = () => {
  try {
    sessionStorage.removeItem(AGE_GATE_KEY);
  } catch {
    /* ignore */
  }
};

/**
 * Age / liability gate before viewing sensitive media.
 * Requires an explicit 18+ checkbox before confirm is enabled.
 */
const AgeGateModal = ({ open, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  const [confirmedAge, setConfirmedAge] = useState(false);

  useEffect(() => {
    if (open) setConfirmedAge(false);
  }, [open]);

  if (!open) return null;

  const handleConfirm = () => {
    if (!confirmedAge) return;
    setAgeGatePassed();
    onConfirm?.();
  };

  const handleCancel = () => {
    setConfirmedAge(false);
    onCancel?.();
  };

  return (
    <div className="modal-backdrop" role="dialog" aria-modal="true" aria-labelledby="age-gate-title">
      <div className="modal age-gate">
        <p className="age-gate__badge">18+</p>
        <h2 id="age-gate-title">{t('ageRestriction.title')}</h2>
        <p className="modal__warn">{t('ageRestriction.warning')}</p>
        <p className="modal__text">{t('ageRestriction.disclaimer')}</p>
        <p className="modal__text">{t('ageRestriction.noLiability')}</p>

        <label className="age-gate__check">
          <input
            type="checkbox"
            checked={confirmedAge}
            onChange={(e) => setConfirmedAge(e.target.checked)}
          />
          <span>{t('ageRestriction.confirmAge')}</span>
        </label>

        <p className="age-gate__agree">{t('ageRestriction.agreement')}</p>

        <div className="modal__actions">
          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
            {t('ageRestriction.cancel')}
          </button>
          <button
            type="button"
            className="btn btn-danger"
            disabled={!confirmedAge}
            onClick={handleConfirm}
          >
            {t('ageRestriction.enter')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgeGateModal;
